// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.landlord.v1.CappsLandlordPropertyDetailsWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  AddressAutocompleteWebResponseDto,
  ListingAlias,
  PropertyDetailsResponseDto,
  UpdateApplicationsAcceptedRequestDto,
} from '../..';

interface AutocompleteParams {
  partialAddress: string;
}
interface DetailsParams {
  listingAlias: ListingAlias;
}
interface IsListingPresentParams {
  listingAlias: ListingAlias;
}

export const CappsLandlordPropertyDetailsWebApiHandler_autocomplete_Path =
  '/api/web/landlord/v1/properties/addresses/autocomplete';

/**
 * Get autocomplete addresses for a partial address
 */
export const CappsLandlordPropertyDetailsWebApiHandler_autocomplete = (
  getParams: AutocompleteParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<AutocompleteParams, never, AddressAutocompleteWebResponseDto>(
    {
      getParams: getParams,
      endpoint: CappsLandlordPropertyDetailsWebApiHandler_autocomplete_Path,
      method: 'GET',
      contextPath: '/capps',
    },
    client,
  );
};

export const CappsLandlordPropertyDetailsWebApiHandler_details_Path = '/api/web/landlord/v1/properties/details';

export const CappsLandlordPropertyDetailsWebApiHandler_details = (getParams: DetailsParams, client = getClient()) => {
  return httpFrontEndRequest<DetailsParams, never, PropertyDetailsResponseDto>(
    {
      getParams: getParams,
      endpoint: CappsLandlordPropertyDetailsWebApiHandler_details_Path,
      method: 'GET',
      contextPath: '/capps',
    },
    client,
  );
};

export const CappsLandlordPropertyDetailsWebApiHandler_isListingPresent_Path =
  '/api/web/landlord/v1/properties/isListingPresent';

export const CappsLandlordPropertyDetailsWebApiHandler_isListingPresent = (
  getParams: IsListingPresentParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<IsListingPresentParams, never, boolean>(
    {
      getParams: getParams,
      endpoint: CappsLandlordPropertyDetailsWebApiHandler_isListingPresent_Path,
      method: 'GET',
      contextPath: '/capps',
    },
    client,
  );
};

export const CappsLandlordPropertyDetailsWebApiHandler_updateApplicationsAccepted_Path =
  '/api/web/landlord/v1/properties/updateApplicationsAccepted';

export const CappsLandlordPropertyDetailsWebApiHandler_updateApplicationsAccepted = (
  postData: UpdateApplicationsAcceptedRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UpdateApplicationsAcceptedRequestDto, void>(
    {
      endpoint: CappsLandlordPropertyDetailsWebApiHandler_updateApplicationsAccepted_Path,
      method: 'POST',
      contextPath: '/capps',
      postData: postData,
    },
    client,
  );
};
